export { default as googleIcon } from './google-icon.svg';
export { default as firefoxIcon } from './firefox-icon.svg';
export { default as safariIcon } from './safari-icon.svg';
export { default as edgeIcon } from './edge-icon.svg';
export { default as starTestimonial } from './star.svg';
export const person1 = require('./person1.png?webp');
export const person2 = require('./person2.png?webp');
export const person3 = require('./person3.png?webp');
export const macbookImage = require('./mackbookImage.png?webp');
export const videoInstructionImage = require('./videoInstruction.jpg?webp');
export const phoneNoteImg1 = require('./phone-note-1.png?webp');
export const phoneNoteImg2 = require('./phone-note-2.png?webp');
export const phoneNoteImg1x2 = require('./phone-note-1-2x.png?webp');
export const phoneNoteImg2x2 = require('./phone-note-2-2x.png?webp');
export const screenImg1 = require('./screen-1.jpg?webp');
export const screenImg2 = require('./screen-2.jpg?webp');
export const e51Image = require('./e5-1.png?webp');
export const e52Image = require('./e5-2.jpg?webp');
export const e52Image2x = require('./e5-2-2x.jpg?webp');
export const macbookPerformance = require('./macbook-performance.png?webp');
export const macbookPerformance2x = require('./macbook-performance-2x.png?webp');
export const codeCardBg = require('./code-card-bg.png?webp');
